import ReceivablesDashboard from './ReceivablesDashboard';

export default {
  edit: {},
  list: {
    receivables: ReceivablesDashboard,
  },
};
